import React, { useLayoutEffect } from "react";
import { useSWRConfig, SWRConfig } from "swr";
import { injectSWRCache, isMetaCache } from "./swr-cache";
var injected = new WeakSet();
var inject = function (cache) {
    return injectSWRCache(cache, function (key, value) {
        if (isMetaCache(key)) {
            return;
        }
        window.postMessage({
            type: "updated_swr_cache",
            payload: {
                key: key,
                value: value,
            },
        }, "*");
    });
};
var swrdevtools = function (useSWRNext) { return function (key, fn, config) {
    useLayoutEffect(function () {
        window.postMessage({ type: "initialized" }, "*");
    }, []);
    // FIXME: I'll use mutate to support mutating from a devtool panel.
    var cache = useSWRConfig().cache /* , mutate */;
    if (!injected.has(cache)) {
        inject(cache);
        injected.add(cache);
    }
    return useSWRNext(key, fn, config);
}; };
export var SWRDevTools = function (_a) {
    var children = _a.children;
    return React.createElement(SWRConfig, { value: { use: [swrdevtools] } }, children);
};
//# sourceMappingURL=SWRDevTools.js.map